<script setup lang="ts">
    const props = defineProps<{
        modelValue: string
        label?: string
        name?: string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [string]
    }>()

    const modelValue = computed({
        get: () => props.modelValue,
        set: (value: string) => {
            emit('update:modelValue', value)
        },
    })
</script>

<template>
    <div>
        <VvInputText
            v-model="modelValue"
            class="pk-input-color"
            :name="name"
            type="color"
            icon="ri:sip-line"
            icon-position="after"
            :label="label" />
    </div>
</template>

<style lang="scss">
    .pk-input-color {
        .vv-input-text__icon-after {
            width: var(--spacing-18);
            height: var(--spacing-18);
            border-radius: 100%;
            position: absolute;
            top: var(--spacing-14);
            right: 0;
        }
    }
</style>
